var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustryValueChain5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.015,
    height: 35.963,
    viewBox: "0 0 37.015 35.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2717.776 -1251.114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2721.742 1265.012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.922,0V22.064H-17.163V0h1.554V20.519H10.368V0Z",
    transform: "translate(17.163)",
    fill: "#edaa30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2717.776 1251.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.843l8.417-11.2L8.56-3.5l9.468-7.412.48-.376.48.376L28.455-3.5l.142.146,8.417,11.2-1.244.924L27.413-2.351,18.507-9.324,9.6-2.351,1.246,8.766Z",
    transform: "translate(0 11.29)",
    fill: "#edaa30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.868-107.957H71.995v11.33h7.873ZM71.219-109.5H81.426v14.423H70.441V-109.5Z",
    transform: "translate(2660.351 1378.356)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2731.479 1269.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.515,0l8.89,12.166-1.257.907L-.742.907Z",
    transform: "translate(0.742)",
    fill: "#edaa30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2731.479 1269.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16.371l-8.89,12.166-1.257-.9L2.9-.534Z",
    transform: "translate(5.988 0.534)",
    fill: "#edaa30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77-114.716H73.2v6.057H77Zm-4.576-1.549h6.131v9.151H71.644v-9.151Z",
    transform: "translate(2661.186 1373.659)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.162-112.663H69.815v2.576h1.347Zm-2.125-1.547h3.679v5.669H68.259v-5.669Z",
    transform: "translate(2658.835 1375.087)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.377-112.663H78.03v2.576h1.347Zm-2.125-1.547h3.679v5.669H76.474v-5.669Z",
    transform: "translate(2664.542 1375.087)",
    fill: "#edaa30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryValueChain5);
export default __webpack_public_path__ + "static/media/industry-value-chain-5.b5b7a0407cdf4e11037c3b7f0ce59445.svg";
export { ForwardRef as ReactComponent };